// =============================================================================
//  Copyright : 2023 semantics GmbH
//  Date      : $Date: 2025-09-21 19:16:35 +0200 (Sun, 21 Sep 2025) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 156393 $
//  Purpose   : wrap sui modal
// =============================================================================
// ---Third-party imports
import React from 'react'
import {Modal as SuiModal} from 'semantic-ui-react'

import {useFullscreenContext} from 'uix/hooks'

const Modal = ({...props}) => {
  let {domNode} = useFullscreenContext()
  return <SuiModal {...props} mountNode={domNode || undefined} />
}
Modal.Content = SuiModal.Content
Modal.Actions = SuiModal.Actions
Modal.Description = SuiModal.Description
Modal.Dimmer = SuiModal.Dimmer
Modal.Header = SuiModal.Header

export {Modal}
